import { Component, Input, OnInit, OnDestroy } from '@angular/core';

@Component({
  selector: 'app-generate-loader',
  templateUrl: './generate-loader.component.html',
  styleUrls: ['./generate-loader.component.scss']
})

export class GenerateLoaderComponent implements OnInit, OnDestroy {
  @Input() displayText: string = '';
  @Input() genearateSuccess: boolean = false;
  @Input() reGenerate: boolean = false;

  progressPercentage: number = 0;
  typedText: string = '';
  private progressInterval: any;
  private progressSpeed: number = 100; // milliseconds between updates
  private typingInterval: any;
  private typingSpeed: number = 50; // milliseconds between characters

  ngOnInit() {
    if (!this.genearateSuccess) {
      this.startProgressSimulation();
      this.startTypingEffect();
    }
  }

  ngOnDestroy() {
    if (this.progressInterval) {
      clearInterval(this.progressInterval);
    }
    if (this.typingInterval) {
      clearInterval(this.typingInterval);
    }
  }

  private startProgressSimulation() {
    this.progressPercentage = 0;
    this.progressInterval = setInterval(() => {
      if (this.progressPercentage < 95) {
        // Simulate realistic progress with varying speeds
        const increment = Math.random() * 3 + 1; // Random increment between 1-4
        this.progressPercentage = Math.min(this.progressPercentage + increment, 95);
      }
    }, this.progressSpeed);
  }

  private startTypingEffect() {
    this.typedText = '';
    let currentIndex = 0;

    this.typingInterval = setInterval(() => {
      if (currentIndex < this.displayText.length) {
        this.typedText += this.displayText[currentIndex];
        currentIndex++;
      } else {
        clearInterval(this.typingInterval);
      }
    }, this.typingSpeed);
  }

  getProgressRingOffset(): number {
    const circumference = 2 * Math.PI * 54; // 2πr where r=54
    const progress = this.progressPercentage / 100;
    return circumference * (1 - progress);
  }
}
